import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import ReleasesCard from "./ReleasesCard";
import HelpCard from "./HelpCard";
import {useTranslation} from "react-i18next";

function HomeView() {
  const {t} = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Grid container sx={{backgroundColor: "transparent", pl: 0, pr: 0}}>
      <Grid size={12}>
        <Card className="custom-card" data-testid="homeCard">
          <CardContent>
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
              }}>
              <Grid size={12}>
                <Typography gutterBottom variant="h5" component="div" style={{fontWeight: "bold"}}>
                  {t("home.welcomeTitle")}
                </Typography>
              </Grid>
              <Grid size={12}>
                <p>{t("home.welcomeText")}</p>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid
        style={{marginTop: "20px", paddingRight: isMobile ? "0px" : "10px"}}
        size={{
          sm: 12,
          md: 6,
        }}>
        <ReleasesCard></ReleasesCard>
      </Grid>
      <Grid
        style={{marginTop: "20px", paddingLeft: isMobile ? "0px" : "10px"}}
        size={{
          sm: 12,
          md: 6,
        }}>
        <HelpCard></HelpCard>
      </Grid>
    </Grid>
  );
}

export default HomeView;
